import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import { AttachmentBase } from 'src/sb-tools/typescript/models/attachment-base.model';
import { AttachmentType } from 'src/sb-tools/typescript/enums/attachment-type.enum';
import { ImageAllTypes } from '@giphy/js-types';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InlineSVGComponent } from '../../Frontend-Inline-SVG-Module/inline-svg.component';
import { GiphyPopoverComponent } from '../giphy-popover/giphy-popover.component';

@Component({
    selector: 'sb-giphy-picker',
    templateUrl: './giphy-picker.component.html',
    styleUrls: ['./giphy-picker.component.scss'],
    imports: [PopoverModule, TranslateModule, TooltipModule, InlineSVGComponent, GiphyPopoverComponent],
})
export class GiphyPickerComponent {
    @ViewChild('giphyPopover') giphyPopoverElement: PopoverDirective;

    @Input() isDisabled: boolean;

    @Output() add: EventEmitter<AttachmentBase> = new EventEmitter();

    private attachmentTypeEnum = AttachmentType;

    addGifAttachment(giphy: ImageAllTypes): void {
        this.add.emit(this.getGifAttachmentModel(giphy));
        this.hide();
    }

    hide(): void {
        this.giphyPopoverElement.hide();
    }

    private getGifAttachmentModel(gif: ImageAllTypes): AttachmentBase {
        return {
            url: gif.url,
            isContentPart: true,
            mimeType: 'image/gif',
            attachments: [],
            attachmentType: this.attachmentTypeEnum.image,
        } as AttachmentBase;
    }
}
